import { ESolarActions, SolarActions } from "@edp-store/actions/solar.actions";
import { initialSolarState, ISolarState } from "@edp-store/state/solar.state";

export function SolarReducers(state = initialSolarState, action: SolarActions): ISolarState {
    switch (action.type) {
        case ESolarActions.SetSolarContract: {
            const newValue: any = {};
            newValue[action.accountNumber] = action.payload;
            return {
                ...state,
                solarContracts: {...state.solarContracts, ...newValue },
            };
        }
        default: {
            return state;
        }
    }
}
